// 敏感词管理
import http from "@/jslibs/axios/http";
import utils from "@/jslibs/utils";

// 敏感词列表
export const list = (data) => http.get("/v1/cms/SensitiveWord", data);

// 敏感词新增
export const add = (data) => http.post("/v1/cms/SensitiveWord", data);

// 敏感词编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/SensitiveWord/${uuid}`, data);

// 敏感词删除
export const del = (data) => http.delete(`/v1/cms/SensitiveWord/${data.uuid}`);

// 敏感词详情
export const detail = ({ uuid, ...data }) => http.get(`/v1/cms/SensitiveWord/${uuid}`, data);

// 敏感词导入
export const _import = ({ file }) => {
    const params = new FormData();
    params.append("file", file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post("/v1/cms/SensitiveWord/import", params, config);
};

// 敏感词导入模板下载
export const download = () => utils.downloadFile(`/v1/cms/SensitiveWord/template?export=1`);
